import React from "react";
import { Mail, Phone, LifeBuoy } from "lucide-react";
import a1 from "../assets/bg.webp";

const Contact = () => {
  return (
    <section className="relative">
      {/* Background image with overlay */}
      <div className="relative h-[600px] md:h-[700px]">
        <img
          src={a1}
          alt="Contact background"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-black/60"></div>

        {/* Form + heading over image */}
        <div className="absolute inset-0 flex flex-col justify-center items-center px-4 md:px-8">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4 text-center">
            Contact Us
          </h2>
          <p className="text-gray-200 text-center mb-8 max-w-2xl">
            We use an agile approach to test assumptions and connect with the
            needs of your audience early and often.
          </p>

          {/* Form */}
          <div className="bg-white -mb-52 rounded-xl shadow-lg p-6 md:p-12 w-full max-w-3xl">
            <form className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <input
                type="text"
                placeholder="First Name"
                className="border border-gray-300 rounded-lg p-3 w-full focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
              <input
                type="text"
                placeholder="Last Name"
                className="border border-gray-300 rounded-lg p-3 w-full focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
              <input
                type="email"
                placeholder="Your email"
                className="border border-gray-300 rounded-lg p-3 w-full focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
              <input
                type="text"
                placeholder="Phone Number"
                className="border border-gray-300 rounded-lg p-3 w-full focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
              <textarea
                placeholder="Your message"
                className="border border-gray-300 rounded-lg p-3 w-full md:col-span-2 h-32 focus:outline-none focus:ring-2 focus:ring-blue-500"
              ></textarea>
              <button
                type="submit"
                className="md:col-span-2 bg-blue-600 text-white font-semibold py-3 rounded-lg hover:bg-blue-700 transition"
              >
                Send message
              </button>
            </form>
          </div>
        </div>
      </div>

      {/* Spacer to prevent overlap */}
      <div className="h-24 md:h-32"></div>

 <div className="max-w-7xl mx-auto px-4 md:px-8 grid grid-cols-1 md:grid-cols-3 gap-6 mb-16">
  {/* Card 1 */}
  <div className="bg-white rounded-xl p-6 flex flex-col items-center text-center shadow transition-all duration-500 hover:bg-gradient-to-br hover:from-green-400 hover:to-green-800 hover:text-white">
    <Mail className="w-8 h-8 mb-3 transition-colors duration-500" />
    <h4 className="font-semibold mb-1 transition-colors duration-500">Email us:</h4>
    <p className="text-gray-600 text-sm transition-colors duration-500">
      Email us for general queries, including marketing and partnership opportunities.
    </p>
    <a href="mailto:hello@flowbite.com" className="mt-2 font-medium transition-colors duration-500">
      hello@flowbite.com
    </a>
  </div>

  {/* Card 2 - Middle card (default active) */}
  <div className="bg-green-200 rounded-xl p-8 md:p-6 flex flex-col items-center text-center shadow transform scale-105 transition-all duration-500 hover:bg-gradient-to-br hover:from-green-400 hover:to-green-800 hover:text-white">
    <Phone className="w-8 h-8 mb-3 transition-colors duration-500" />
    <h4 className="font-semibold mb-1 transition-colors duration-500">Call us:</h4>
    <p className="text-gray-700 text-sm transition-colors duration-500">
      Call us to speak to a member of our team. We are always happy to help.
    </p>
    <a href="tel:+16467865060" className="mt-2 font-medium transition-colors duration-500">
      +1 (646) 786-5060
    </a>
  </div>

  {/* Card 3 */}
  <div className="bg-white rounded-xl p-6 flex flex-col items-center text-center shadow transition-all duration-500 hover:bg-gradient-to-br hover:from-green-400 hover:to-green-800 hover:text-white">
    <LifeBuoy className="w-8 h-8 mb-3 transition-colors duration-500" />
    <h4 className="font-semibold mb-1 transition-colors duration-500">Support</h4>
    <p className="text-gray-600 text-sm transition-colors duration-500">
      Email us for general queries, including marketing and partnership opportunities.
    </p>
    <button className="mt-2 px-4 py-2 rounded-lg bg-blue-600 text-white hover:bg-blue-700 transition-colors duration-500">
      Support center
    </button>
  </div>
</div>


    </section>
  );
};

export default Contact;
